import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { IngestionPartCreateForm } from "./components/IngestionPartCreateForm";

export function NewIngestionPartPage() {
  return (
    <Page title="New Ingestion Part">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <IngestionPartCreateForm />
      </Container>
    </Page>
  );
}
